import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[var(--line)] bg-bone">
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5 mb-5">
            <div className="w-8 h-8 rounded-full bg-ink grid place-items-center text-xs font-bold text-white">F</div>
            <span className="font-display text-ink text-lg font-bold">
              Freedom In Me
              <span className="text-[var(--muted-2)] font-normal mx-1.5">/</span>
              <span className="font-serif-em italic font-light text-brand">Build Lab</span>
            </span>
          </div>
          <p className="text-[var(--muted)] max-w-md leading-relaxed">
            A live online build lab from Freedom In Me LLC. Where strategy meets execution. Stop waiting. Start building.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-brand mb-4 font-medium">The Lab</div>
          <ul className="space-y-2 text-ink/80 text-sm">
            <li><a href="#how" className="hover:text-brand">How it works</a></li>
            <li><a href="#build" className="hover:text-brand">What you build</a></li>
            <li><a href="#offer" className="hover:text-brand">Pricing</a></li>
            <li><a href="#faq" className="hover:text-brand">FAQ</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="font-mono-spec text-[11px] uppercase tracking-[0.22em] text-brand mb-4 font-medium">Freedom In Me</div>
          <ul className="space-y-2 text-ink/80 text-sm">
            <li><a href="https://itsthefreedominme.com" target="_blank" rel="noreferrer" className="hover:text-brand">itsthefreedominme.com</a></li>
            <li><a href="mailto:info@itsthefreedominme.com" className="hover:text-brand">info@itsthefreedominme.com</a></li>
            <li><Link to="/admin" data-testid="footer-admin-link" className="hover:text-brand">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--line)] py-6 text-center text-xs text-[var(--muted)]">
        &copy; {new Date().getFullYear()} Freedom In Me LLC. All rights reserved.
      </div>
    </footer>
  );
}
